import { render, staticRenderFns } from "./role-manage.vue?vue&type=template&id=4e5da463&scoped=true&"
import script from "./role-manage.vue?vue&type=script&lang=js&"
export * from "./role-manage.vue?vue&type=script&lang=js&"
import style0 from "./role-manage.vue?vue&type=style&index=0&id=4e5da463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5da463",
  null
  
)

export default component.exports